import axios from 'axios';
import { UserService } from './user.service';

// Request interceptor
axios.interceptors.request.use(
    config => {
        const token = UserService.GetAuthMSAuthorizationToken();
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

export default axios;
